/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the chatbots endpoint.
 */
export function transformReadChatbotConfigurationsResponse(response) {
    return {
        data: {
            chatbots: response,
        },
        meta: {},
    };
}
/**
 * Returns the transformed response to match our ApiResponse format.
 *
 * @param response The raw response from the chatbots endpoint.
 */
export function transformCreateChatbotConfigurationResponse(response) {
    return {
        data: response,
        meta: {},
    };
}
